// Keep this in sync with:
// app/controllers/agency/orders_controller.rb
export const pendingStatuses = ['Awaiting Review', 'Booked', 'Pending']

export function statusColor(statusTitle, fallbackColor = 'black'){
  const colors = {
    'Awaiting Review': '#e78d2d',
    Approved: '#8c9fbf',
    Booked: '#d0c6b1',
    Complete: '#43ac6a',
    Declined: '#e2001a',
    Delivered: '#43ac6a',
    Dispatched: '#43ac6a',
    Held: '#d0c6b1',
    Installed: '#43ac6a',
    Packaged: '#d0c6b1',
    Pending: '#e78d2d',
    Printed: '#d0c6b1',
    Processed: '#d0c6b1',
    Processing: '#b69deb',
    Rejected: '#e2001a',
    Released: '#e78d2d',
    Removed: '#e2001a',
    Sent: '#d0c6b1',
    Urgent: '#e2001a',
  }

  return colors[statusTitle] || fallbackColor
}

export const statusNames = [
  'Awaiting Review',
  'Approved',
  'Booked',
  'Complete',
  'Declined',
  'Delivered',
  'Dispatched',
  'Held',
  'Installed',
  'Packaged',
  'Pending',
  'Printed',
  'Processed',
  'Processing',
  'Rejected',
  'Released',
  'Removed',
  'Sent',
  'Urgent',
]

export default statusColor
